<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :loading="loading"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props.sync="footerProps"
      class="elevation-1"
      @update:options="updateTable()"
    >
      <template #top>
        <v-card-title>
          <v-toolbar flat>
            <v-toolbar-title>A/B Buckets</v-toolbar-title>

            <v-spacer />

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @input="searchTable()"
            />

            <v-spacer />

            <v-btn
              class="btn-bg-deep-blue mr-6"
              text-color="white"
              @click="openAbTestReportModal = true"
            >
              A/B Test Report
            </v-btn>

            <v-btn
              v-if="!isProd"
              class="btn-bg-deep-blue"
              text-color="white"
              @click="openWaterfallTestModal = true"
            >
              Watefall Test
            </v-btn>
          </v-toolbar>
        </v-card-title>
      </template>

      <template #item.default_ratio="{ item }">
        <span>
          {{ item.default_ratio | percentage }}
        </span>
      </template>

      <template #item.testing_ratio="{ item }">
        <span>
          {{ item.testing_ratio | percentage }}
        </span>
      </template>

      <template #item.is_active="{ item }">
        {{ item.is_active ? 'Yes' : 'No' }}
      </template>

      <template #item.actions="{ item }">
        <v-btn
          v-if="hasPermission('edit ab-testing::ab-buckets')"
          class="btn-bg-deep-blue mr-5"
          text-color="white"
          @click="handleViewBucketDetails(item)"
        >
          <v-icon left>
            mdi-eye
          </v-icon>
          Bucket Details
        </v-btn>
        <disabled-for-lack-of-role-btn
          v-else
          text="Bucket Details"
          permission="edit ab-testing::ab-buckets"
          :x-small="false"
          button-class="mx-2"
        />

        <v-btn
          v-if="hasPermission('view ab-testing::ab-tests')"
          text-color="white"
          @click="handleViewCampaigns(item)"
        >
          <v-icon left>
            mdi-eye
          </v-icon>
          A/B Tests
        </v-btn>
        <disabled-for-lack-of-role-btn
          v-else
          text="A/B Tests"
          :x-small="false"
          permission="view ab-testing::ab-tests"
          button-class="mx-2"
        />
      </template>
    </v-data-table>

    <AbBucketDetails
      v-if="openBucketDetails && activeBucket"
      :bucket-id="activeBucket?.id"
      @close="handleBucketClose"
      @bucket-saved="handleBucketSaved"
    />

    <AbTestIndex
      v-if="showBucketAbTestIndex && activeBucket"
      :bucket-data="activeBucket"
      @close="showBucketAbTestIndex = false"
    />

    <AbWaterfallTest
      v-if="openWaterfallTestModal"
      :ab-buckets="items"
      @close="openWaterfallTestModal = false"
    />

    <AbTestReport
      v-if="openAbTestReportModal"
      @close="openAbTestReportModal = false"
    />
  </div>
</template>

<script setup>
import dataTableMixin from '@/mixins/dataTableMixin';
import DisabledForLackOfRoleBtn from '@/views/DisabledForLackOfRoleBtn.vue';
import AbBucketDetails from './Components/AbBucketDetails.vue';
import AbTestIndex from './Components/AbTestIndex.vue';
import AbWaterfallTest from './Components/AbWaterfallTest.vue';
import AbTestReport from './Components/Reports/Index.vue';
</script>

<script>
export default {
  name: 'AbBucketIndex',

  mixins: [dataTableMixin],

  data: () => ({
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Name', value: 'bucket_name' },
      { text: 'Type', value: 'bucket_type' },
      { text: 'Default Router %', value: 'default_ratio' },
      { text: 'Testing %', value: 'testing_ratio' },
      { text: 'Is Active ?', value: 'is_active' },
      { text: '', value: 'actions', sortable: false },
    ],

    openBucketDetails: false,
    showBucketAbTestIndex: false,
    activeBucket: null,
    openWaterfallTestModal: false,
    openAbTestReportModal: false,
  }),

  methods: {
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/ab-buckets', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },

    handleViewBucketDetails(item) {
      this.activeBucket = item;
      this.openBucketDetails = true;
    },

    handleBucketSaved() {
      this.openBucketDetails = false;
      this.activeBucket = null;
      this.updateTable();
    },

    handleBucketClose() {
      this.openBucketDetails = false;
      this.activeBucket = null;
    },

    handleViewCampaigns(item) {
      this.activeBucket = item;
      this.showBucketAbTestIndex = true;
    },
  },
};
</script>
